// extracted by mini-css-extract-plugin
export var actionText = "_rt-4";
export var container = "_rt-0";
export var leftSection = "_rt-1";
export var rightSection = "_rt-2";
export var settingsButton = "_rt-6";
export var settingsIcon = "_rt-7";
export var shortcut = "_rt-5";
export var shortcutGroup = "_rt-3";